import React from 'react';
import { authRoles } from 'app/auth';

const SetPasswordConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/set-password',
			component: React.lazy(() => import('./index'))
		}
	]
};

export default SetPasswordConfig;
